import {NotifyHelper} from "../../../helpers/toast";
import {eThuPhiTuyenSinhActionsObj} from "../../action-types/thu-phi-tuyen-sinh/IThuPhiTuyenSinhActionTypes";
import {generateActionForKey, generateActions} from "../generateActions";

export const thuPhiTuyenSinhActions = {
    ...generateActions(eThuPhiTuyenSinhActionsObj, "THU_PHI_TUYEN_SINH"),
    ...generateActionForKey(
        eThuPhiTuyenSinhActionsObj,
        "THU_PHI_TUYEN_SINH",
        "CREATE_BIENLAITHU_SUCCESS",
        () => {
            NotifyHelper.Success("Đã tạo biên lai");
        }
    ),
    ...generateActionForKey(
        eThuPhiTuyenSinhActionsObj,
        "THU_PHI_TUYEN_SINH",
        "CREATE_BIENLAITHU_ERROR",
        (m) => {
            NotifyHelper.Error(m.data);
        }
    ),
    ...generateActionForKey(
        eThuPhiTuyenSinhActionsObj,
        "THU_PHI_TUYEN_SINH",
        "ADD_NEW_TAB_BY_ID_ERROR",
        (m) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eThuPhiTuyenSinhActionsObj,
        "THU_PHI_TUYEN_SINH",
        "UPDATE_BIENLAITHU_SUCCESS",
        () => {
            NotifyHelper.Success("Đã sửa biên lai");
        }
    ),
    ...generateActionForKey(
        eThuPhiTuyenSinhActionsObj,
        "THU_PHI_TUYEN_SINH",
        "UPDATE_BIENLAITHU_ERROR",
        (m) => {
            NotifyHelper.Error(m.data);
        }
    ),
    ...generateActionForKey(
        eThuPhiTuyenSinhActionsObj,
        "THU_PHI_TUYEN_SINH",
        "LOAD_EDIT_BIENLAI_ERROR",
        (m) => {
            NotifyHelper.Error(m.data);
        }
    ),
};
